<div class="body">

    <ng-container *ngIf="appointments.length > 0; else noAppointments">

        <div *ngFor="let appointment of appointments" class="appointment-entry">

            <div class="status-indicator">
                <mat-spinner *ngIf="(step.status|async) === StepStatus.Started" diameter=20></mat-spinner>
                <mat-icon *ngIf="(step.status|async) === StepStatus.Succeeded">done</mat-icon>
                <mat-icon *ngIf="(step.status|async) === StepStatus.Failed">clear</mat-icon>
            </div>
            <div class="title">{{appointment.title}}</div>

        </div>

    </ng-container>

</div>

<ng-template #noAppointments>

    <div class="no-entries-hint">

        <div class="text">Keine Termine</div>

    </div>

</ng-template>
